<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="cxcdepcli"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmcxcdepcli" title="Confirmar Acción" appendTo="body">
</p-confirmDialog>
<div class="p-grid" style="width: 98%">
    <div class="p-col-12">
        <app-invmaebarra (signal)="manejarSenales($event)" [botonNuevo]="botonNuevo" [botonGuardar]="botonGuardar"
            [botonBorrar]="botonBorrar" [botonRegresar]="false"  [barraBotones3]="barraBotones2"
            [barraBotones3]="barraBotones2"
            [barraBotonesAsiCon]="barraBotones2"
            [botonPrimero]="!botonPrimero" [botonAnterior]="!botonAnterior" [botonSiguiente]="!botonSiguiente"
            [botonUltimo]="!botonUltimo" [barraBotones5]="true"
            [botonBuscarPermanente]="true" [botonDescargaPermanente]="true"
            [botongeneraanc]="true" [botonreversaanc]="true"
            ></app-invmaebarra>
    </div>
</div>
<div class="p-grid" style="margin-top: -10px; margin-bottom: -10px; width: 99%;">
	<!--LINEA 1-->
	<div class="p-col-5">
		
	</div>
	<div class="p-col-1">
		<label for="lblestado"></label>
		<input class="frm" id="lblestado" type="text" pInputText
			style="background-color: rgb(40,138,210); font-weight: bold; color: white;" [disabled]="true"
			[(ngModel)]="lblestado" (keydown.enter)="setFocus($event)"
			 autocomplete="off">
	</div>
	
</div>

<p-tabView [(activeIndex)]="index" (onChange)="changeTabs()" [style]="{'width':'98%'}">
    <p-tabPanel header="General">
        <p-scrollPanel [style]="{'width':'100%', 'height':'calc(100vh - 270px)'}">
            <div class="contorno" id="contorno">
                <div class="divgrups">
                    <div class="p-grid">
                        <!--LINEA 1-->
                        <div class="p-col-1">
                            <span>Número:</span>
                        </div>
                        <div class="p-col-1">
                            <label for="ENCDEPCLI_NUMERO"></label>
                            <input class="frm" id="ENCDEPCLI_NUMERO" type="text" pInputText disabled [(ngModel)]="cxcdepositocliService.encdepcli[indicador].ENCDEPCLI_NUMERO"
                                style="color: blue; font-weight: bold;" autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <span>Banco:</span>
                        </div>
                        <div class="p-col-2">
                            <label for="BAN_CODIGO"></label>
                            <input class="frm" id="BAN_CODIGO" type="text" pInputText [disabled]="cxcdepositocliService.encdepcli[indicador].ENCDEPCLI_NUMERO !== ''"
                                [(ngModel)]="cxcdepositocliService.encdepcli[indicador].BAN_CODIGO"
                                (keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
                                autocomplete="off">
                        </div>
                        <div class="p-col-1">
                            <button type="button"
                                style="background-image: url(../../../assets/images/iconos/buscar.webp);"
                                (click)="busquedabanco(cxcdepositocliService.encdepcli[indicador].BAN_CODIGO)"></button>
                        </div>
                        <div class="p-col-2">
                            <label for="lblbannombre"></label>
                            <input class="frm" id="lblbannombre" type="text" pInputText disabled
                                style="color: blue;"
                                [(ngModel)]="lblbannombre"
                                autocomplete="off">
                        </div>
                        <!--LINEA 2-->
                        <div class="p-col-12" style="margin-top: -10px">
                            <div class="p-grid">
                                <div class="p-col-1">
                                    <span>Fecha:</span>
                                </div>
                                <div class="p-col-1">
									<p-calendar id="ENCDEPCLI_FECHA"
										[inputStyle]="{width: '100%', height: '20px'}"
										[(ngModel)]="cxcdepositocliService.encdepcli[indicador].ENCDEPCLI_FECHA"
										[readonlyInput]="false" dateFormat="dd/mm/yy" (keydown.enter)="setFocus($event)"
										(keydown)="botonesmodificar()">
									</p-calendar>
								</div>
                                <div class="p-col-1">
                                    <span>Concepto:</span>
                                </div>
                                <div class="p-col-5">
									<label for="ENCDEPCLI_CONCEPTO"></label>
									<input class="frm" id="ENCDEPCLI_CONCEPTO" type="text" pInputText
										[(ngModel)]="cxcdepositocliService.encdepcli[indicador].ENCDEPCLI_CONCEPTO"
										(keydown.enter)="setFocus($event)" (keydown)="botonesmodificar()"
										autocomplete="off">
								</div>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <app-aggridsaci 
            [width]=""
            [height]="80" 
            [enableSorting]="false" 
            [enableFilter]="true"
            [rowData]="cxcdepositocliService.detdepcli" 
            [frameworkComponents]="frameworkComponents"
            [animateRows]="true" 
            [rowSelection]="rowSelection" 
            [columnDefs]="columnDefsCxcdepcli"
            [defaultColDef]="defaultCxdetdepcli" 
            [rowStyle]="rowStyle" 
            [singleClickEdit]="false" 
            [botones]="true"
            [mostrarGuardar]="false" 
            [botonesAdicionales]="false" 
            [comboOpciones]=""
            [solobotoneliminar]="true"
            [btnsubirxls]="false"
            (selected)="seleccionItem($event)" 
            [tipodetalle]=""
            [botonBorrar]="true"
            (cambios)="cambio($event)"
            [CC]="true"
            >
            </app-aggridsaci>
            <div class="divgrups" style="margin-top: 10px;">
                <div class="p-grid" style="margin-bottom: -10px;">
                    <div class="p-col-4">
                        <span>Comprobantes ya registrados en bancos o en depósito de clientes</span>
                    </div>
                    <div class="p-col-1" style="margin-top: 10px; height: 25%; background-color: rgb(245,236,166)">
                    </div>
                    <div class="p-col-1">
                        <span for="total" class="obligatorio">Total:</span>
                    </div>
                    <div class="p-col-4">
                        <input type="text" id="total" class="totales" [disabled]="true"
                            [(ngModel)]="cxcdepositocliService.regtotal" autocomplete="off">
                    </div>
                </div>
            </div>
        </p-scrollPanel>
    </p-tabPanel>
</p-tabView>

<p-dialog header="Busqueda de Datos" [(visible)]="displayDialogBusquedaFast"
		  [transitionOptions]="'0ms'"
		  [modal]="true"
		  appendTo="body"
		  [style]="{width: '70vw', height: '70vh'} ">
	<app-busquedadlg [arrayOptions]="types" [arregloConsulta]="arregloCons" [consulta]="consulta" [tabla]="tabla"
					 [where]="where"
					 [busquedaParams]="busquedacampos"
					 (opcionSeleccionada)="manejarSeleccion($event)"></app-busquedadlg>
</p-dialog>

<input #inputFile type="file" style="display: none; opacity: 0.0; position: absolute; 
			top: 0; left: 0; bottom: 0; right: 0; width: 25px; height: 25px; cursor: pointer;" accept=".xls, .xlsx"
    (change)="onBasicUpload(inputFile.files)" />

    <div style=" 	position: fixed;
				z-index: 999;
				height: 2em;
				width: 2em;
				overflow: visible;
				margin: auto;
				top: 0;
				left: 0;
				bottom: 0;
				right: 0;

				">
    <p-progressSpinner *ngIf="spin" [style]="{width: '100px', height: '100px'}" animationDuration=".5s">
    </p-progressSpinner>
    <p-dialog [(visible)]="spin" [transitionOptions]="'0ms'" [modal]="true" [closable]="false"
        [style]="{ opacity: 0.00}" position="top">
    </p-dialog>
</div>

<p-dialog header="Clave Autorización" [(visible)]="displayDialogAutorizacion" [transitionOptions]="'0ms'" [modal]="true"
	appendTo="body" (onHide)="onHideAutorizacion()" [style]="{width: '40vw', height: 'auto'} ">
	<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="autorizacion"></p-toast>
	<div class="divgrups">
		<div class="p-grid">
			<div class="p-col-12">
				<div class="p-grid">
					<div class="p-col-1"></div>
					<div class="p-col-4">
						<label for="clave" style="font-weight: bold">Clave de Autorización:</label>
					</div>
					<div class="p-col-2"></div>
					<div class="p-col-4">
						<input type="password" pInputText id="clave" [(ngModel)]="claveAuth"
							(keydown.enter)="comprobarClave()" placeholder="Ingrese la clave">
					</div>
					<div class="p-col-1"></div>
				</div>
			</div>
		</div>
	</div>
</p-dialog>